var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.585888 9.65593C-0.253342 10.1346 -0.17536 11.4112 0.719571 11.7823L5.92948 13.9532V17.7865C5.92948 18.4582 6.47164 19 7.14377 19C7.50397 19 7.8456 18.8404 8.07583 18.5621L10.3781 15.8049L14.9791 17.7197C15.6809 18.0129 16.4941 17.5527 16.6092 16.8031L18.9858 1.36576C19.0564 0.916736 18.8596 0.464006 18.4845 0.207953C18.1095 -0.0480999 17.6193 -0.0703654 17.222 0.156L0.585888 9.65593ZM2.52057 10.6022L15.2019 3.36223L7.04722 12.4688L7.09178 12.5059L2.52057 10.6022ZM14.9642 15.7864L8.77767 13.2073L16.7281 4.32706L14.9642 15.7864Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.8d11b32045eb6299b624027c96780b61.svg";
export { ForwardRef as ReactComponent };